import { ActivityTab } from 'components/ActivityTab';
import { DetailTimeOffViewGeneralTab } from 'components/TimeOffModal/views/DetailTimeOffView/DetailTimeOffViewGeneralTab';

export const DetailTimeOffViewTabComponentMap = {
  General: DetailTimeOffViewGeneralTab,
  Activity: ActivityTab,
};

export type DetailTimeOffViewTabType = keyof typeof DetailTimeOffViewTabComponentMap;
